import { ChapterItemType } from '@/types/module'
import { Types } from '../constant'

export const getSelectionType = (type: string) => {
  return Types.find((item) => item.value === type)?.title
}

export const getSelectionChapter = (type: string, arr: ChapterItemType[]) => {
  return arr.find((item) => item.chapter_id.toString() === type)?.chapter_name
}

export const getQuestionType = (type: string) => {
  return Types.find((item) => item.value === type)?.title ?? ''
}

export const getSubQuestionLetter = (text: string) => {
  const arrStr = text.split('.')
  return arrStr[0]
}
